export default __webpack_public_path__ + "static/media/sound-off.155de9df.svg";